import { ClientDetailPage } from '@repo/ui/features/superadmin';
import { useParams } from 'react-router-dom';

export default function SuperAdminClientDetailPage() {
  const { id } = useParams();
  return (
    <div className="w-full py-6">
      <ClientDetailPage clientId={Number(id)} />
    </div>
  );
}
